import * as actions from './actions'

const companyModule = {
  namespaced: true,
  actions,
}

export default companyModule
